import { GetStaticProps } from 'next'
import { connect } from 'react-redux'
import Careers from '#/containers/Careers/components/apply'
import {
  getAllPostsWithSlug,
  getPostAndMorePosts
} from '#/containers/Careers/lib/api'
import { SendResume } from '#/store/actions/user'

const mapStateToProps = (state: TopHap.StoreState) => ({
  asyncStatus: state.global.status,
  user: state.user.info
})

const mapDispatchToProps = { sendResume: SendResume }

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false
}) => {
  const data = await getPostAndMorePosts(params?.slug, preview)

  return {
    props: { job: data.job },
    revalidate: 1
  }
}

type Node = {
  node: {
    slug: string
  }
}

export async function getStaticPaths() {
  const allJobs = await getAllPostsWithSlug()

  return {
    paths: allJobs.edges.map(({ node }: Node) => `/careers/${node.slug}/apply`),
    fallback: true
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Careers)
